<template>
    <div class="c c-dealers">
        <DealerModule assetsFolder="/Assets/Images/dealers"
                      apiUrl=""
                      apiKey="AIzaSyBt2H9cM-O7VuCfLezoOyvcvI7IB3DfoBU"
                      translationsUrl="/umbraco/api/translations/getalltranslations?locale=nl-NL&dictionaryKey=Dealers"
                      :culture="settings.culture"
                      numberOfResults="100"
                      >
            <template #searchButton="searchButton">
                <button class="btn btn-primary"
                        type="button"
                        id="searchform"
                        @click="searchButton.search(searchButton.localSearchTerm)">
                    <i class="far fa-search"></i>
                </button>
            </template>

            <template #filterButton="filterButton">
                <div class="dm-filter__button"
                     @click="filterButton.toggleFilters">
                    <i class="far fa-arrow-down"></i>
                    <span>{{ filterButton.translations.FilterTitle }}</span>
                </div>
            </template>

            <template #filterItem="filterItem">
                <div class="dm-filter__item"
                     v-for="category in filterItem.allCategories"
                     :key="category.Id">
                    <div class="custom-control custom-checkbox flex-grow">
                        <input type="checkbox"
                               class="custom-control-input"
                               :id="'filter' + category.CodeName"
                               :value="category.DisplayName"
                               @change="
                                filterItem.changeFilter(category.DisplayName)
                            "
                               v-model="filterItem.selectedFilters" />
                        <label class="custom-control-label"
                               :for="'filter' + category.CodeName">
                            <img :src="filterItem.getMarker(category.CodeName)"
                                 width="18"
                                 height="22" />
                            <span>{{ category.DisplayName }}</span>
                        </label>
                    </div>
                    <div class="dm-tooltip"
                         v-if="category.Tooltip !== null"
                         :class="{ open: filterItem.openTooltip }">
                        <div class="dm-tooltip__button"
                             @click="filterItem.toggleTooltip()">
                            <i class="far fa-info-circle"></i>
                        </div>
                        <div class="dm-tooltip__body">
                            {{ category.Tooltip }}
                        </div>
                    </div>
                </div>
            </template>

            <template #filterPostText="filterPostText">
                <div class="dm-filter__post"
                     v-if="filterPostText.translations.FilterPostText != null"
                     v-html="filterPostText.translations.FilterPostText"></div>
            </template>

            <template #results="results">
                <div class="dm-results__items">
                    <div class="dm-result"
                         @click="results.selectDealer(dealer)"
                         v-for="dealer in results.foundDealers"
                         :key="dealer.Id">
                        <div class="dm-result__distance">
                            <img :src="results.getMarker(dealer.Categories)"
                                 width="30"
                                 height="37" />
                            <span>
                                {{ dealer.Distance.toFixed(1) }}
                                {{ results.translations.Kilometers }}
                            </span>
                        </div>
                        <div class="dm-result__info">
                            <strong>{{ dealer.Name }}</strong><br />{{ dealer.Address }}<br />{{
                                dealer.Postcalcode
                            }}
                            {{ dealer.City }}
                        </div>
                    </div>
                </div>
            </template>

            <template #resultOverlay="resultOverlay">
                <div class="dm-resultoverlay__button"
                     @click="resultOverlay.clearActiveDealer()">
                    <i class="far fa-angle-left"></i>
                    <span>{{ resultOverlay.translations.Back }}</span>
                </div>
                <div class="dm-resultoverlay__body">
                    <div class="dm-resultoverlay__title">
                        {{ resultOverlay.activeDealer.Name }}
                    </div>
                    <div class="dm-resultoverlay__info">
                        <div>{{ resultOverlay.activeDealer.Address }}</div>
                        <div>
                            {{ resultOverlay.activeDealer.Postalcode }}
                            {{ resultOverlay.activeDealer.City }}
                        </div>
                        <div>{{ resultOverlay.activeDealer.Country }}</div>
                    </div>
                    <a :href="'tel:' + resultOverlay.activeDealer.Phone"
                       target="_blank"
                       class="dm-resultoverlay__phone"
                       v-if="resultOverlay.activeDealer.Phone !== ''">
                        <i class="far fa-phone"></i>
                        <span>{{ resultOverlay.activeDealer.Phone }}</span>
                    </a>
                    <a :href="
                            'mailto:' + resultOverlay.activeDealer.EmailAddress
                        "
                       target="_blank"
                       class="dm-resultoverlay__email"
                       v-if="
                            resultOverlay.activeDealer.EmailAddress &&
                                resultOverlay.activeDealer.EmailAddress !== ''
                        ">
                        <i class="far fa-envelope"></i>
                        <span>
                            {{
                            resultOverlay.activeDealer.EmailAddress
                            }}
                        </span>
                    </a>
                    <a :href="resultOverlay.activeDealer.Website"
                       target="_blank"
                       class="dm-resultoverlay__website"
                       v-if="
                            resultOverlay.activeDealer.Website &&
                                resultOverlay.activeDealer.Website !== ''
                        ">
                        <i class="far fa-globe"></i>
                        <span>
                            {{
                            resultOverlay.translations.VisitWebsite
                            }}
                        </span>
                    </a>
                    <a :href="
                            'https://www.google.com/maps/dir//' +
                                resultOverlay.activeDealer.Address.replace(
                                    ' ',
                                    '+'
                                ) +
                                '+' +
                                resultOverlay.activeDealer.Postalcode.replace(
                                    ' ',
                                    '+'
                                ) +
                                '+' +
                                resultOverlay.activeDealer.City.replace(
                                    ' ',
                                    '+'
                                ) +
                                '/@' +
                                resultOverlay.activeDealer.Position.Lat +
                                ',' +
                                resultOverlay.activeDealer.Position.Lng
                        "
                       target="_blank"
                       class="dm-resultoverlay__route">
                        <i class="far fa-route"></i>
                        <span>
                            {{
                            resultOverlay.translations.RoutePlanner
                            }}
                        </span>
                    </a>
                </div>
            </template>
        </DealerModule>
    </div>
</template>

<script>
    import { DealerModule } from '@frontisbv/frontisdealermodule';

    export default {
        components: {
            DealerModule
        },
        data() {
            return {};
        },
        props: {
            settings: {
                type: Object,
                required: true
            }
        }
    };
</script>
